import { render, staticRenderFns } from "./collateral-build-publish-widget.vue?vue&type=template&id=57165e58&"
import script from "./collateral-build-publish-widget.vue?vue&type=script&lang=js&"
export * from "./collateral-build-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./collateral-build-publish-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports